import { render } from "./HeaderDropdown.vue?vue&type=template&id=be120c80&scoped=true&ts=true"
import script from "./HeaderDropdown.vue?vue&type=script&lang=ts"
export * from "./HeaderDropdown.vue?vue&type=script&lang=ts"

import "./HeaderDropdown.vue?vue&type=style&index=0&id=be120c80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be120c80"],['__file',"src/components/header/HeaderDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be120c80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be120c80', __exports__)) {
    api.reload('be120c80', __exports__)
  }
  
  module.hot.accept("./HeaderDropdown.vue?vue&type=template&id=be120c80&scoped=true&ts=true", () => {
    api.rerender('be120c80', render)
  })

}


export default __exports__